import { createLoader } from '@spotify-internal/creator-data-loading';
import type { ProvidersDirectoryType } from './types';
import { fetchEntry } from '../Contentful';

export type ServiceLoaderProps = {
  smartlingLanguage: string;
  preview?: boolean;
};

export const serviceLoader = createLoader<
  ServiceLoaderProps,
  ProvidersDirectoryType | null
>(
  async ({ preview, smartlingLanguage }) => {
    return (await fetchEntry<ProvidersDirectoryType>({
      contentType: 'providersDirectory',
      filters: { title: 'master' },
      locale: smartlingLanguage,
      preview,
    })) as ProvidersDirectoryType | null;
  },
  {
    cache: false,
  },
);
